import React, { Suspense, lazy } from "react";
import { Helmet } from "react-helmet";

// Import the critical components normally (they will be part of the main bundle)
import Hero from "./Hero";
import Services from "./Services";
const FlipCards = lazy(() => import("./FlipCards"));

// Lazy load non-critical components
const ExclusivePackages = lazy(() => import("./ExclusivePackages"));
const Testimonials = lazy(() => import("./Testimonials"));
const ValueableClients = lazy(() => import("./ValueableClients"));
const RequestCallback = lazy(() => import("./RequestCallback"));
const BusinessLicense = lazy(() => import("./BusinessLicense"));
const AnimatedCircle = lazy(() => import("./Animation"));
const Separator = lazy(() => import("./Separator"));
const HomeCostCalculator = lazy(() => import("./HomeCostCalculator"));

// Loading fallback component
const LoadingFallback = () => (
  <div className="loading-container">
    <div className="loading-spinner"></div>
  </div>
);

function Home() {
  return (
    <>
      <Helmet>
        <title>Business Setup in Dubai, UAE | 100% Ownership | Right One</title>
        <meta
          name="description"
          content="Start your company in Dubai with 100% ownership, lifetime visa, and bank account support. Fast mainland, free zone, and offshore business setup in UAE."
        />
        <meta
          name="keywords"
          content="business setup in Dubai, company formation UAE, 100% ownership Dubai, UAE free zone company, Dubai mainland license, offshore company UAE, visa assistance UAE, start a company in Dubai, corporate bank account UAE, UAE business consultancy"
        />
        <link rel="canonical" href="https://rightone.ae/" />

        {/* Open Graph / Facebook */}
        <meta
          property="og:title"
          content="Business Setup in Dubai, UAE | 100% Ownership | Right One"
        />
        <meta
          property="og:description"
          content="Start your company in Dubai with 100% ownership, lifetime visa, and bank account support."
        />
        <meta property="og:url" content="https://rightone.ae/" />
        <meta
          property="og:image"
          content="https://rightone.ae/Assets/seo/og-image.jpg"
        />
        <meta property="og:type" content="website" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Business Setup in Dubai, UAE | 100% Ownership | Right One"
        />
        <meta
          name="twitter:description"
          content="Start your company in Dubai with 100% ownership, lifetime visa, and bank account support."
        />
        <meta
          name="twitter:image"
          content="https://rightone.ae/Assets/seo/og-image.jpg"
        />
      </Helmet>
      
      {/* Critical components that should load immediately */}
      <Hero />
      <FlipCards />

      {/* Group components that are visible above the fold or closely related */}
      <Suspense fallback={<LoadingFallback />}>
        <Services />
        <ExclusivePackages />
      </Suspense>

      {/* Group middle components */}
      <Suspense fallback={<LoadingFallback />}>
        <BusinessLicense />
        <HomeCostCalculator />
        <Testimonials />
      </Suspense>

      {/* Group components at the bottom */}
      <Suspense fallback={<LoadingFallback />}>
        <ValueableClients />
        <AnimatedCircle />
        <Separator />
        <RequestCallback />
      </Suspense>
    </>
  );
}

export default Home;
